import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "Profile" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
